import React from 'react';
import {render} from "react-dom";
import {FormStepperComponent} from '../form-page/FormStepper.component';
import {FormFooterComponent} from '../form-page/FormFooter.component';
import {FormWidgetTimeSlots} from "./widget-time-slots/FormWidgetTimeSlots";
import {getQueryParams}  from "../../helpers/getQueryParams";

export class ExtensiveFormPageController
{
    constructor() {
        this.service = 'RegistrationService';
        this.sessionPage = parseInt(window.sessionStorage.getItem(this.service + 'FormPage') || 0);
        this.initialPage = getQueryParams('form_page') || this.sessionPage;
        this.$form = $('[data-controller="ExtensiveFormPageController"]').find('form');
        this.$fileInput = $('input[type="file"]');
        this.pages = ["Gegevens ouder", "Gegevens leerling", "Bijlesvakken", "Bijleslocatie", "Contactmoment"];

        // bind events
        $('.js-toggle-student-info').on('change', () => this.toggleAdditionalInfo());
        $('.js-toggle-student-contact').on('change', () => this.toggleStudentContactInfo());

        // render
        this.renderReactFormComponents();

        // Initiate the widget in the last step of the form
        new FormWidgetTimeSlots();
    }

    /**
     * Render the form header en footer
     */
    renderReactFormComponents() {
        render(
            <FormStepperComponent
                pages={this.pages}
                initialPage={this.initialPage}/>,
            $('FormStepperComponent')[0]
        );

        render(
            <FormFooterComponent
                pages={this.pages}
                $form={this.$form}
                service={this.service}
                initialPage={this.initialPage}/>,
            $('FormFooterComponent')[0]
        );
    }

    /**
     * Toggles the address fields in case the customer wants
     * to receive tutor somewhere else
     */
    toggleAdditionalInfo() {
        const show = $('[name="tutoringLocation"]:checked').val();
        const $field = $('.js-additional-student-field');
        if ('true' === show) {
            $field.slideDown();
        } else {
            $field.slideUp();
        }
    }

    /**
     * Toggles the student contact if the student and customer are
     * the same person
     */
    toggleStudentContactInfo() {
        const isStudent = $('[name="customerIsStudent"]:checked').length;
        const $field = $('.js-student-contact-field');
        if (0 === isStudent) {
            $field.slideDown();
        } else {
            $field.slideUp();
        }
    }

}
